import { Typography } from "antd";
import { FormattedMessage } from "react-intl";
import styled from "styled-components";
import { ActionButton } from "../Buttons";

export const AudioPlayerContainer = styled.div`
  background: ${({ theme }) => theme.palette.background.paper};
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

export const StyledAudio = styled.audio`
  width: 100%;
  height: 30px;
`;

type Props = {
  voiceFile: string;
  showDownload?: boolean;
  title?: string | false;
  containerStyle?: React.CSSProperties;
};

const VoicePlayer = (props: Props) => {
  const {
    voiceFile,
    showDownload = true,
    title = "common.audioRecording",
    containerStyle,
  } = props;

  return (
    <AudioPlayerContainer style={containerStyle}>
      {title && (
        <Typography.Text strong style={{ width: "100px" }}>
          <FormattedMessage id={title} />
        </Typography.Text>
      )}
      {voiceFile ? (
        <StyledAudio controls>
          <source src={voiceFile} type="audio/mpeg" />
          <source src={voiceFile} type="audio/wav" />
          Your browser does not support the audio element.
        </StyledAudio>
      ) : (
        <FormattedMessage id="common.na" />
      )}
      {voiceFile && showDownload && (
        <ActionButton type="download" href={voiceFile} size="large" noLabel />
      )}
    </AudioPlayerContainer>
  );
};

export default VoicePlayer;
